/* eslint-disable complexity */
import AddListItemCommentModal from './modal/add_comment';
import { BoardTaskObject } from '../../params/redux/task';
import CheckIcon from '@mui/icons-material/Check';
import DeleteTaskItemModal from './modal/delete_task_item';
import { markTaskListItemCompleteThunk } from '../../redux/thunks/task';
import TaskFilePickerModal from './modal/file_picker';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Attachment, MessageOutlined, MoreVert, Visibility } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { brand, green, orange, red } from '../../theme/themePrimitives';
import { settingAddingTask, settingSelectedBoardTaskDetail, settingViewTaskItemDetail } from '../../redux/slices/task';
import { useDispatch, useSelector } from 'react-redux';

interface TaskListItemComponentProps {
    taskItem: BoardTaskObject;
    assigned?: boolean;
}

const TaskListItemComponent = ({ taskItem, assigned = false }: TaskListItemComponentProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { currentUser } = useSelector((state: RootState) => state.app);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [commentModal, setCommentModal] = useState<number>(0);
    const [deleting, setDeleting] = useState<boolean>(false);
    const [fileModal, setFileModal] = useState<number>(0);

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlerViewDetail = () => {
        dispatch(settingViewTaskItemDetail(true));
        dispatch(settingSelectedBoardTaskDetail(taskItem));
    };

    const markAsCompleteHandler = async () => {
        try {
            await dispatch(markTaskListItemCompleteThunk({
                id: taskItem.id,
                is_completed: taskItem.is_completed === 0 ? 1 : 0,
                client_id: id ? parseInt(id as string, 10) : 0
            })).unwrap();
        } catch (e) {
            // Catch errors
        }
    };

    const editTaskListItemHandler = () => {
        dispatch(settingAddingTask(true));
        dispatch(settingSelectedBoardTaskDetail(taskItem));
    };


    return <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle2" color="textSecondary">{taskItem.title}</Typography>
            <Box display="flex" alignItems="center">
                <IconButton size="small" onClick={handlerViewDetail}>
                    <Visibility />
                </IconButton>
                {taskItem.created_by === currentUser?.id && <IconButton size="small" onClick={handleMenuClick}>
                    <MoreVert />
                </IconButton>}
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    {taskItem.created_by === currentUser?.id && <MenuItem onClick={markAsCompleteHandler}>{taskItem.is_completed === 1 ? 'Mark as incomplete' : 'Mark as complete'}</MenuItem>}
                    {taskItem.is_completed === 0 && !assigned && taskItem.created_by === currentUser?.id && <MenuItem onClick={editTaskListItemHandler}>Edit Task</MenuItem>}
                    {taskItem.is_completed === 0 && !assigned && taskItem.created_by === currentUser?.id && <MenuItem onClick={() => setDeleting(true)}>Delete Task</MenuItem>}
                </Menu>
            </Box>
        </Box>
        <Box mt={0} mb={3} display="flex" alignItems="center" justifyContent="space-between">
            <Box
                mt={1}
                borderRadius="10px"
                width="max-content"
                padding="2px 10px"
                color={taskItem.label_color_tag === 'danger' ? red[300] : taskItem.label_color_tag === 'warning' ? orange[300] : taskItem.label_color_tag === 'success' ? green[400] : brand[300]}
                bgcolor={taskItem.label_color_tag === 'danger' ? red[100] : taskItem.label_color_tag === 'warning' ? orange[100] : taskItem.label_color_tag === 'success' ? green[200] : brand[100]}>
                <Typography variant="body2" fontSize="small">{taskItem.label}</Typography>
            </Box>
            <Box>
                <Typography variant="body2" color={green[500]} display="flex" alignItems="center" gap={0.5}>{taskItem.is_completed === 1 ? <CheckIcon /> : ''} {taskItem.is_completed === 1 ? 'Completed' : ''}</Typography>
            </Box>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
                {/* <IconButton><Attachment fontSize="small" onClick={taskItem.is_completed === 0 && !assigned ? () => setFileModal(taskItem.id) : () => null} /></IconButton> */}
                <IconButton><Attachment fontSize="small" /></IconButton>
                <Typography variant="body2" color="textSecondary" marginRight="10px">{taskItem.files?.length}</Typography>
                <IconButton >
                    {/* <IconButton onClick={taskItem.is_completed === 0 && !assigned ? () => setCommentModal(taskItem.id) : () => null}> */}
                    <MessageOutlined fontSize="small" />
                </IconButton>
                <Typography variant="body2" color="textSecondary">{taskItem.comments?.length}</Typography>
            </Box>
            {/* {taskItem.members && taskItem.members.length > 0
                ? <AvatarGroup max={4}>
                    {taskItem?.members?.map((assignee: TaskListItemMemberObject) => (
                        <Tooltip key={assignee.id} title={assignee.member_id}>
                            <Avatar src={assignee.member_id.toString()} sx={{ width: 30, height: 30, bgcolor: gray[300], color: 'white' }}>
                                {assignee.user.first_name.charAt(0)}
                                            {assignee.user.last_name.charAt(0)}
                            </Avatar>
                        </Tooltip>
                    ))}
                </AvatarGroup>
                : (
                    <Typography variant="body2" color="textSecondary">No Assignees</Typography>
                )} */}
        </Box>
        {/* Modals */}
        <AddListItemCommentModal open={commentModal !== 0} onClose={() => setCommentModal(0)} selectedId={commentModal} />
        <TaskFilePickerModal open={fileModal !== 0} onClose={() => setFileModal(0)} selectedId={fileModal} />
        <DeleteTaskItemModal open={deleting} onClose={() => setDeleting(false)} taskItem={taskItem} />
    </Box>;
};

export default TaskListItemComponent;